//@flow
import React from 'react';
import {Tooltip} from 'react-tippy';
import s from './StackedBar.less';
import {percentOfTotalNotFixed, percentOfTotal} from '../../../helpers';

type Props = {
  data: Object,
  totalFobTooling: number,
};

const StackedBar = ({
  data,
  totalFobTooling,
  totalFobwithoutTooling,
  otherAdjustmentCost,
}: Props) => {
  if (!data) return null;

  //Calculates what the new 100% is if there is a negative adjustment because the
  //so the FOB bar sections fit all on one line as expected.
  //This is necessary because with a discount, the percentages will not add up to 100%, but will be higher.
  //Therefore, they can't be used directly as the widths.
  const totalFobToolingAdj = otherAdjustmentCost >= 0
    ? totalFobTooling
    : totalFobTooling + Math.abs (otherAdjustmentCost);

  return (
    <div className={`${s.chart}`}>
      {Object.keys (data).map (section => {
        const maxPercentToDisplay = 0.024;
        const percentOfFOB = percentOfTotal (
          totalFobwithoutTooling,
          data[section].sectionSummary.cost
        );
        return data[section].sectionSummary.cost
          ? <Tooltip
              key={section}
              followCursor={true}
              html={
                <div className={`${s.toolTip}`}>
                  <strong>
                    {section}
                    : $
                    {data[section].sectionSummary.cost.toFixed (2)}
                    {' '}
                    {`(${percentOfFOB})`}
                  </strong>
                </div>
              }
              trigger="mouseenter"
            >
              <span
                className={`${s.block} ${s[section.split (' ')[0]]}`}
                style={{
                  width: percentOfTotalNotFixed (
                    totalFobToolingAdj,
                    data[section].sectionSummary.cost
                  ),
                }}
              >
                <span className={`${s.value}`}>
                  {data[section].sectionSummary.cost / totalFobTooling >
                    maxPercentToDisplay &&
                    !isNaN (data[section].sectionSummary.cost / totalFobTooling)
                    ? percentOfFOB
                    : ''}
                </span>
              </span>
            </Tooltip>
          : null;
      })}
    </div>
  );
};

export default StackedBar;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/StackedBar/StackedBar.js